module.exports = __webpack_public_path__ + "img/tipocontacto09.d1520ef.svg";